import { useEffect, useState } from "react";
import axios from "axios";
import { BASE_URL } from "../../utils/commonUrl";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import {useSelector} from "react-redux";

const ValueAssessmentChart = ({quarterID}) => {
  const {user} = useSelector((state) => state["auth"]);
  const [assessmentAvgData, setAssessmentAvgData] = useState([]);

  useEffect(() => {
    GetAssessmentAvgData(quarterID);
  }, [quarterID]);

  const GetAssessmentAvgData = (id) => {
    id = parseInt(id) < 0 ? 0 : id;
    //console.log(id);
    axios
      .post(BASE_URL + `/api/dashboard/GetAssessmentAvgData/${id}`)
      .then((response) => {
        setAssessmentAvgData(response.data);
      })
      .catch(console.error);
  };

  const _yData = assessmentAvgData.map((data) => data.assestmentName);
  const _dataValue = assessmentAvgData.map((data) => data.avgWeight);

  const options = {
    chart: {
      type: "column",
    },
    title: {
      text: "Core Values",
    },
    xAxis: {
      type: "category",
      labels: {
        rotation: -25,
        style: {
          fontSize: "13px",
          fontFamily: `'Poppins', sans-serif`,
        },
      },
      categories: _yData,
    },
    yAxis: {
      min: 1,
      title: {
        text: "Weight",
      },
    },
    plotOptions: {
        column: {
            colorByPoint: true
        }
    },
    colors: ["#7cb5ec", "#434348", "#90ed7d", "#f7a35c", "#8085e9", "#f15c80", "#e4d354", "#2b908f", "#f45b5b", "#91e8e1"],
    legend: {
      enabled: false,
    },
    tooltip: {
      pointFormat: "Value Assessment: <b>{point.y:.1f}</b>",
    },
    series: [
      {
        name: "Value Assessment",
        data: _dataValue,
      },
    ],
  };

  return <HighchartsReact highcharts={Highcharts} options={options} />;
};

export default ValueAssessmentChart;
